import { render, staticRenderFns } from "./RootUI.vue?vue&type=template&id=ecd65c42&scoped=true&"
import script from "./RootUI.vue?vue&type=script&lang=js&"
export * from "./RootUI.vue?vue&type=script&lang=js&"
import style0 from "./RootUI.vue?vue&type=style&index=0&id=ecd65c42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd65c42",
  null
  
)

export default component.exports